export default __webpack_public_path__ + "static/media/img2.fb00efa2.png";